import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import { fetchSalesOrderDetail, setValue, fetchBachesByID } from '../../actions/sales_actions';
import { fetchSalesOrdersByDate, convertToInvoice, convertingToInvoiceReset, clearConvertingToInvoice, clearUpdateSalesInvoice } from '../../actions/dispatch_actions';
import { fetchSalesInvoiceDetail, updateSalesInvoiceReset, updateSalesInvoice } from '../../actions/salesInvoice_actions';
import { emailSelectedSalesInvoices } from '../../actions/purchaseOrders_actions';

import { printSalesInvoice } from '../../actions/print_actions';
import SalesShippingModal from '../../components/Sales/salesShippingModal';

let salesShippingModal = reduxForm({
    form: 'salesShippingModal',
    // validate
})(SalesShippingModal);


salesShippingModal = connect(
  state => ({
    initialValues: state.salesOrders.currentSalesOrderDetail,
  })
)(salesShippingModal);

const selector = formValueSelector('salesShippingModal');
const selector2 = formValueSelector('salesOrderForm');

function mapStateToProps(state) {
  const chosenOrderNum = selector(state, 'Sales_Order_No');
  const ShippingDate = selector(state, 'ShippingDate');

  const PaymentType = selector(state, 'PaymentType');
  const InvoiceShipDate = selector(state, 'InvoiceShipDate');
  const PaymentNum = selector(state, 'PaymentNum');

  const trackingNumber = selector(state, 'trackingNumber');
  const shipCarrier = selector(state, 'shipCarrier');
  const shipMethod = selector(state, 'shipMethod');

  const discount = selector2(state, 'Discount');
  const savings = selector2(state, 'Savings');
  const taxRate = selector2(state, 'TaxRate');

  const Company_id = selector(state, 'Company_id');
  const Pickup_Warehouse_id = selector(state, 'Pickup_Warehouse_id');
  
  return {
    chosenOrderNum,
    ShippingDate,
    PaymentType,
    InvoiceShipDate,
    PaymentNum,
    
    trackingNumber,
    shipCarrier,
    shipMethod,
    
    discount,
    savings,
    taxRate,
    
    Company_id,
    Pickup_Warehouse_id,

    salesOrders: state.dispatch.salesOrders,
    salesOrdersIsLoading: state.dispatch.salesOrdersIsLoading,
    salesOrdersError: state.dispatch.salesOrdersError,
    salesInvoiceDetail: state.salesInvoice.currentSalesInvoiceDetail,
    detailIsLoading: state.salesInvoice.detailIsLoading,
    detailError: state.salesInvoice.detailError,

    salesOrderDetail: state.salesOrders.currentSalesOrderDetail,
    salesOrderIsLoading: state.salesOrders.detailIsLoading,
    salesOrderError: state.salesOrders.detailError,

    convertingToInvoice: state.dispatch.convertingToInvoice,
    convertToInvoiceSuccess: state.dispatch.convertToInvoiceSuccess,
    convertToInvoiceFailure: state.dispatch.convertToInvoiceFailure,
    convertToInvoiceError: state.dispatch.convertToInvoiceError,
    refreshConvertingToInvoice: state.dispatch.refreshConvertingToInvoice,

    salesInvoiceIsUpdating: state.salesInvoice.salesInvoiceIsUpdating,
    salesInvoiceUpdateError: state.salesInvoice.salesInvoiceUpdateError,
    salesInvoiceUpdated: state.salesInvoice.salesInvoiceUpdated,
    initialValues: state.salesInvoice.currentSalesInvoiceDetail,

    requestingSalesInvoicePdf: state.print.requestingSalesInvoicePdf,
    salesInvoicePdf: state.print.salesInvoicePdf,
    
    batchesInfo: state.salesOrders.batchesInfo,
    selectedCompany: state.header.selectedCompany,
    selectedWarehouse: state.header.selectedWarehouse,
  };
}

export default connect(mapStateToProps, { 
  fetchSalesOrderDetail, 
  fetchSalesOrdersByDate, 
  updateSalesInvoiceReset,
  convertingToInvoiceReset, 
  clearConvertingToInvoice,
  clearUpdateSalesInvoice,
  convertToInvoice, 
  updateSalesInvoice, 
  fetchSalesInvoiceDetail, 
  emailSelectedSalesInvoices,
  setValue,
  printSalesInvoice,
  fetchBachesByID
})(salesShippingModal);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/salesShippingModal.jsx